import Mosaic from 'mosaic-framework';

import Logo from '../../res/MosaicLogo.png';
import '../styles/navigation-bar.less';


export default new Mosaic({
    name: 'navigation-bar',
    view() {
        return html`
        ${
            window.location.pathname !== '/' ?
            html`<img onclick='${() => this.router.send('/')}' src='${Logo}' alt='Mosaic.js "M" Logo'>`
            : ''
        }

        <button onclick='${() => this.router.send('/mosaic')}'>Docs</button>
        <button onclick='${() => this.router.send('/install')}'>Install</button>
        <button onclick='${() => window.open('https://github.com/authman2/Mosaic')}'>Github</button>
        <button onclick='${() => window.open('https://www.npmjs.com/package/mosaic-framework')}'>NPM</button>
        `
    }
})